import { Box } from '@wix/design-system';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { classNames } from '../../../util';
import { useBiEngagement } from '../../bi';
import { RefreshNotification } from '../../common/components/RefreshNotification';
import { HelpCenterBreadcrumbs } from '../../help-center/components/Breadcrumbs/Breadcrumbs';
import { Header } from '../../help-center/components/Header';
import { MobileLandscape } from '../../help-center/components/MobileLandscape';
import { RequestSuccessManagerNotification } from '../../help-center/components/RequestSuccessManagerNotification';
import { SearchBar } from '../../help-center/components/SearchBar';
import { selectRequestSuccessManagerSent } from '../../pages/RequestSuccessManagerForm/redux/selectors';
import { renderModel } from '../../util/renderModel';
import {
  usePostUrlChange,
  usePresentedState,
  useSessionExpired,
  useSyncUrlState,
  useWidgetUrlEvents,
} from '../hooks';
import styles from '../styles.scss';

// TODO: remove after moving mobile to contact app
const isMobile = renderModel.isMobile();
const isWixStudio = renderModel.isWixStudio();

export const WidgetLayout: FC = () => {
  const isRequestSuccessManagerSent = useSelector(selectRequestSuccessManagerSent);
  usePresentedState();
  useBiEngagement();
  useWidgetUrlEvents();
  useSyncUrlState();
  usePostUrlChange();
  const { showSessionExpired, setShowSessionExpired, pageRef } = useSessionExpired();

  return (
    <Box
      direction="vertical"
      width="100%"
      height="100%"
      backgroundColor="D80"
      className={classNames([isWixStudio && styles.helpCenterWixStudio])}
      dataHook="help-center-widget"
      ref={pageRef}
    >
      <Box backgroundColor="D10" direction="vertical" padding="SP4 SP2 SP2" gap="SP2">
        <Header />
        <SearchBar />
      </Box>
      <HelpCenterBreadcrumbs />
      <Box position="relative" overflow="hidden" align="center" flexGrow={1}>
        <Outlet />
      </Box>
      {isMobile && <MobileLandscape />}
      {isRequestSuccessManagerSent && <RequestSuccessManagerNotification />}
      {showSessionExpired && (
        <RefreshNotification hideRefreshNotification={() => setShowSessionExpired(false)} />
      )}
    </Box>
  );
};
